/**
 * ME+EM Style Quick Add & Swatch Logic
 */
(function() {
  'use strict';

  function filterSizesForColor(wrapper, targetColor) {
    if (!wrapper) return;
    const sizeBtns = wrapper.querySelectorAll('.card-quick-add-size-btn');
    if (!sizeBtns.length) return;

    const hasColor = wrapper.getAttribute('data-has-color') === 'true';
    if (!hasColor) {
      sizeBtns.forEach(btn => btn.style.display = 'inline-flex');
      return;
    }

    sizeBtns.forEach(btn => {
      const btnColor = (btn.getAttribute('data-color') || '').trim().toLowerCase();
      if (!btnColor || btnColor === targetColor) {
        btn.style.display = 'inline-flex';
      } else {
        btn.style.display = 'none';
      }
    });
  }

  function openSizesDrawer(wrapper) {
    if (!wrapper) return;
    const currentColor = (wrapper.getAttribute('data-current-color') || '').trim().toLowerCase();
    if (currentColor) {
      filterSizesForColor(wrapper, currentColor);
    }
    wrapper.classList.add('is-open');
    const sizesDrawer = wrapper.querySelector('.card-quick-add-sizes');
    if (sizesDrawer) sizesDrawer.setAttribute('aria-hidden', 'false');
    const btn = wrapper.querySelector('.card-quick-add-btn');
    if (btn) btn.setAttribute('aria-expanded', 'true');
  }

  function closeSizesDrawer(wrapper) {
    if (!wrapper) return;
    wrapper.classList.remove('is-open');
    const sizesDrawer = wrapper.querySelector('.card-quick-add-sizes');
    if (sizesDrawer) sizesDrawer.setAttribute('aria-hidden', 'true');
    const btn = wrapper.querySelector('.card-quick-add-btn');
    if (btn) btn.setAttribute('aria-expanded', 'false');
  }

  function quickAddToCart(variantId, button) {
    if (!variantId || button.classList.contains('is-loading')) return;

    button.classList.add('is-loading');
    const spinner = button.querySelector('.card-quick-add-size-btn__spinner, .card-quick-add-btn__spinner');
    if (spinner) spinner.classList.remove('hidden');

    const cartDrawer = document.querySelector('cart-drawer');
    const sections = cartDrawer && typeof cartDrawer.getSectionsToRender === 'function'
      ? cartDrawer.getSectionsToRender().map(s => s.section).join(',')
      : 'cart-drawer,cart-icon-bubble,cart-live-region-text';

    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', 1);
    formData.append('sections', sections);
    formData.append('sections_url', window.location.pathname);

    const addUrl = window.routes?.cart_add_url || '/cart/add';

    fetch(addUrl, {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/javascript'
      },
      body: formData
    })
    .then(res => res.json())
    .then(parsedState => {
      if (parsedState.status) {
        const errorMsg = parsedState.description || parsedState.message || 'Could not add item to cart';
        alert(errorMsg);
        return;
      }

      // Publish pub/sub event
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'quick-add', cartData: parsedState });
      }

      // Update cart drawer and open
      if (cartDrawer) {
        if (parsedState.sections && typeof cartDrawer.renderContents === 'function') {
          cartDrawer.renderContents(parsedState);
          if (typeof cartDrawer.open === 'function') cartDrawer.open();
        } else {
          // Fallback: fetch cart-drawer and cart-icon-bubble sections directly
          const cartUrl = window.routes?.cart_url || '/cart';
          fetch(`${cartUrl}?section_id=cart-drawer`)
            .then(r => r.text())
            .then(html => {
              const tempDoc = new DOMParser().parseFromString(html, 'text/html');
              const newInner = tempDoc.querySelector('.drawer__inner');
              const currentInner = cartDrawer.querySelector('.drawer__inner');
              if (currentInner && newInner) {
                currentInner.innerHTML = newInner.innerHTML;
                currentInner.classList.remove('is-empty');
              }
              fetch(`${cartUrl}?section_id=cart-icon-bubble`)
                .then(res => res.text())
                .then(bHtml => {
                  const bDoc = new DOMParser().parseFromString(bHtml, 'text/html');
                  const newB = bDoc.getElementById('cart-icon-bubble') || bDoc.querySelector('.shopify-section');
                  const curB = document.querySelector('#cart-icon-bubble');
                  if (curB && newB && newB.innerHTML.trim()) {
                    curB.innerHTML = newB.innerHTML;
                  }
                })
                .catch(e => console.error('Error updating cart bubble in quick add fallback:', e));
              if (typeof cartDrawer.open === 'function') cartDrawer.open();
            })
            .catch(() => {
              if (typeof cartDrawer.open === 'function') cartDrawer.open();
            });
        }
      } else {
        window.location.href = window.routes?.cart_url || '/cart';
      }

      const wrapper = button.closest('.card-quick-add-wrapper');
      if (wrapper) closeSizesDrawer(wrapper);
    })
    .catch(err => {
      console.error('Quick add error:', err);
    })
    .finally(() => {
      button.classList.remove('is-loading');
      if (spinner) spinner.classList.add('hidden');
    });
  }

  // Delegated Click Handlers
  document.addEventListener('click', function(e) {
    // 1. Color Swatch Click
    const swatchLabel = e.target.closest('.custom_swatch_label');
    if (swatchLabel) {
      const cardWrapper = swatchLabel.closest('.card-wrapper, .grid__item, li');
      if (!cardWrapper) return;

      // Active border
      cardWrapper.querySelectorAll('.custom_swatch_label').forEach(l => l.classList.remove('active'));
      swatchLabel.classList.add('active');

      const targetColor = (swatchLabel.getAttribute('data-color') || swatchLabel.getAttribute('title') || '').trim().toLowerCase();
      if (!targetColor) return;

      // Switch media image
      const images = cardWrapper.querySelectorAll('.card__media img, .media img');
      images.forEach(img => {
        const imgColor = (img.getAttribute('data-color') || '').trim().toLowerCase();
        const imgAlt = (img.getAttribute('alt') || '').trim().toLowerCase();
        const isMatch = (imgColor && imgColor === targetColor) || (imgAlt && imgAlt === targetColor);
        if (isMatch) {
          img.style.opacity = '1';
          img.style.zIndex = '2';
        } else {
          img.style.opacity = '0';
          img.style.zIndex = '1';
        }
      });

      // Update link URL
      const dataUrl = swatchLabel.getAttribute('data-url');
      const parentLinks = cardWrapper.querySelectorAll('.full-unstyled-link, .card__heading a');
      if (dataUrl && parentLinks.length) {
        parentLinks.forEach(link => link.setAttribute('href', dataUrl));
      }

      // Update quick add sizes for this color
      const quickAddWrapper = cardWrapper.querySelector('.card-quick-add-wrapper');
      if (quickAddWrapper) {
        quickAddWrapper.setAttribute('data-current-color', targetColor);
        filterSizesForColor(quickAddWrapper, targetColor);
      }
      return;
    }

    // 2. Close Size Selection
    const closeBtn = e.target.closest('.card-quick-add-sizes__close');
    if (closeBtn) {
      e.preventDefault();
      e.stopPropagation();
      const wrapper = closeBtn.closest('.card-quick-add-wrapper');
      if (wrapper) closeSizesDrawer(wrapper);
      return;
    }

    // 3. Quick Add Trigger Button (for sized products)
    const triggerBtn = e.target.closest('.card-quick-add-btn:not(.card-quick-add-btn--single):not(.is-soldout)');
    if (triggerBtn) {
      e.preventDefault();
      e.stopPropagation();
      const wrapper = triggerBtn.closest('.card-quick-add-wrapper');
      if (!wrapper) return;

      if (wrapper.classList.contains('is-open')) {
        closeSizesDrawer(wrapper);
      } else {
        document.querySelectorAll('.card-quick-add-wrapper.is-open').forEach(w => {
          if (w !== wrapper) closeSizesDrawer(w);
        });
        openSizesDrawer(wrapper);
      }
      return;
    }

    // 4. Single-variant Quick Add Button
    const singleBtn = e.target.closest('.card-quick-add-btn--single');
    if (singleBtn) {
      e.preventDefault();
      e.stopPropagation();
      if (singleBtn.disabled) return;
      const variantId = singleBtn.getAttribute('data-variant-id');
      if (variantId) quickAddToCart(variantId, singleBtn);
      return;
    }

    // 5. Size Selection Pill
    const sizeBtn = e.target.closest('.card-quick-add-size-btn');
    if (sizeBtn) {
      e.preventDefault();
      e.stopPropagation();
      if (sizeBtn.disabled || sizeBtn.classList.contains('is-unavailable')) return;
      const variantId = sizeBtn.getAttribute('data-variant-id');
      if (variantId) quickAddToCart(variantId, sizeBtn);
      return;
    }

    // 6. Click Outside Closes Any Open Drawers
    if (!e.target.closest('.card-quick-add-wrapper')) {
      document.querySelectorAll('.card-quick-add-wrapper.is-open').forEach(w => closeSizesDrawer(w));
    }
  });

  // Init all cards on load
  function initQuickAddCards() {
    document.querySelectorAll('.card-quick-add-wrapper').forEach(wrapper => {
      const currentColor = (wrapper.getAttribute('data-current-color') || '').trim().toLowerCase();
      if (currentColor) {
        filterSizesForColor(wrapper, currentColor);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initQuickAddCards);
  } else {
    initQuickAddCards();
  }

  document.addEventListener('shopify:section:load', initQuickAddCards);
})();
